export default __webpack_public_path__ + "static/media/COVID-19 Tracker.a27bb89d.webp";